import { FormGroup } from '@angular/forms';
import { addRemoveError, checkBoxHelper, getControl, getGroup } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { isBefore } from 'date-fns';
import { isEqual } from 'lodash-es';

export const getContribBiennaleGroup = (form: FormGroup): FormGroup => {
    return getGroup(form, formPaths.contributoBiennale);
};

export const getContribBiennaleControl = (form: FormGroup, path: string) => {
    return getControl(form, `${formPaths.contributoBiennale}.${path}`);
};

export const contribBiennaleCkHelper = (
    form: FormGroup,
    targetPath: string,
    ckPath: string,
    ckTargetValue: number,
    subFormPath: string = formPaths.contributoBiennale,
    suppCondition = true,
    errorStatus?: string
): void => {
    checkBoxHelper(form, targetPath, ckPath, ckTargetValue, subFormPath, suppCondition, errorStatus);
};

export const dataCalcoloPenalitaHelper = (form: FormGroup, targetPath: string) => {
    const my_dataCalcoloPenalitaControl = getControl(form, 'my_dataCalcoloPenalita');
    const targetControl = getControl(form, targetPath);
    const my_DataRevisioneDal = new Date(getControl(form, 'my_SezioneI__Rilevazione.my_DatiIdentificativi.my_DataRevisioneDal')?.value);
    const showError = isBefore(new Date(my_dataCalcoloPenalitaControl?.value), new Date(my_DataRevisioneDal));
    const errors = targetControl.errors ? targetControl.errors : {};

    addRemoveError(showError, errors, 'my_dataCalcoloPenalita', {
        status: 'La data di calcolo delle penalità deve essere successiva alla data di inizio rilevazione.',
    });

    targetControl.setErrors(isEqual(errors, {}) ? null : errors);
};
